import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';

import { ScopeDetailsModal } from './Modal_Scope_Details';
import { AddScopeModal } from './Modal_Add_Scope';
import { AddEstimateItemModal } from './Modal_Add_ItemEstimate_To_Scope';


export function ConsultationDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewConsultationDetailData, setViewConsultationDetailData] = useState([]);


    let [consultationID, setConsultationID] = useState(null);
    let [consultationStatus, setConsultationStatus] = useState(null);

    let [viewScopeList, setViewScopeList] = useState([]);
    let [viewScopeEstimates, setViewScopeEstimates] = useState([]);
    let [viewScopeExpenses, setViewScopeExpenses] = useState([]);
    let [scopeLineNumber, setScopeLineNumber] = useState(null);
    let [showScopeDetailsModal, setShowScopeDetailsModal] = useState(false);
    let [showConsultationDetailsModal, setShowConsultationDetailsModal] = useState(false);
    let [addEstimateItemModal, setAddEstimateItemModal] = useState(false);

    let [estimateLineNumber, setEstimateLineNumber] = useState(null);



   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_consultation_details',
                    user: acctID,
                    xConsultationID: props.data.consultationID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');


                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setConsultationID(cols[0]);
                    setConsultationStatus(cols[10]);

                    setViewScopeList((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols[0],
                            scopeNumber: cols[1],
                            scopeName: cols[3],
                            scopeDescription: cols[4],
                            scopeEstimateAmount: cols[5],
                            scopeExpenses: cols[6],
                            dateLogged: new Date(cols[7]).toISOString().substr(0, 10),
                            assigned: parseFloat(cols[8]).toFixed(2),
                            lastModified: cols[9],
                            status: cols[10],
                        })
                    });


                        let cols_estimates = cols[2].split('#');

                        setViewScopeEstimates((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_estimates[0],
                                scopeNumber: cols_estimates[1],
                                estimateLineNumber: cols_estimates[2],
                                itemID: cols_estimates[3],
                                itemName: cols_estimates[4],
                                itemDescription: cols_estimates[5],
                                itemQuantity: cols_estimates[6],
                                itemEstimatedPrice: parseFloat(cols_estimates[7]).toFixed(2),

                            })
                        });


                        let cols_expenses = cols[2].split('$');

                        setViewScopeExpenses((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_expenses[0],
                                scopeNumber: cols_expenses[1],
                                expenseLineNumber: cols_expenses[2],
                                itemID: cols_expenses[3],
                                itemName: cols_expenses[4],
                                itemDescription: cols_expenses[5],
                                itemQuantity: cols_expenses[6],
                                itemPrice: parseFloat(cols_expenses[7]).toFixed(2),

                            })
                        });

                } 
            })
        }
    }, [props.openModal]);

    function deleteScope(event)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_delete_scope',
                user: acctID,
                xConsultationID: props.data.consultationID,
                xScopeLineNumber: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteScopeItem_estimate(event)
    {



        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_delete_scopeItem_estimate',
                user: acctID,
                xConsultationID: props.data.consultationID,
                xScopeLineNumber: props.data.scopeLineNumber,
                xScopeItem_estimateLineNumber: estimateLineNumber,
                sessionID: sessionID,

            }),
        }


        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function send_customer_approvalRequest()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_send_customerApproval',
                user: acctID,
                xConsultationID: props.data.consultationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }
    
    function add_consultationToProject()
    {
        alert("In Function add_consultationToProject");
    }
    function convert_consultationToProject()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_project',
                user: acctID,
                xConsultationID: props.data.consultationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function viewScopeDescriptionModalHandler(event)
    {
        alert(event[1]);
    }
    function updateItemHandler(event)
    {
        alert("In updateItemHandler");
    }

    function viewDeleteScopeItem_estimateHandler(event) 
    {
        //alert('In viewConsultationInvoiceHandler');
        setConsultationID(event[0]);
        setScopeLineNumber(event[1]);
        setEstimateLineNumber(event[2]);

        deleteScopeItem_estimate();
    }

    function viewScopeExpenseModalHandler(event)
    {
        alert("IN viewScopeExpenseModalHandler");
    }

    function scopeDetailsModalHandler(event) 
    {

        setScopeLineNumber(event[2]);
        setShowScopeDetailsModal(event[0]);
    }

    function deleteScopeHandler(event)
    {
        deleteScope(event);
    }

    function closeModalHandler() {

        setViewConsultationDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Consultation ID</IonCol>
                        <IonCol> {props.data.consultationID} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton>Add Scope</IonButton>
                        </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent >
        <IonGrid className='appGridContent'>
            <IonRow class='gridResultHeaders'>
                <IonCol class='gridResultColumns'>Scope Name</IonCol>
                <IonCol class='gridResultColumns'>Desciption</IonCol>
                <IonCol class='gridResultColumns'>Total Est</IonCol>
                <IonCol class='gridResultColumns'>Action</IonCol>
            </IonRow>
            <div>
                {viewScopeList.map((detailData) =>   {
                    return (
                            <IonRow key={detailData.scopeLineNumber}>
                                <IonCol size='3'>{detailData.scopeName}</IonCol>
                                <IonCol size='3'>
                                    <IonButton onClick={() => viewScopeDescriptionModalHandler([true, detailData.scopeDescription])}></IonButton>
                                </IonCol>
                                <IonCol size='3'>{detailData.scopeEstimateAmount}</IonCol>
                                <IonCol size='3'>
                                    <IonButton className='appListButton' onClick={() => scopeDetailsModalHandler(detailData.consultationID, detailData.scopeLineNumber)}> Details </IonButton>
                                    {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => deleteScopeHandler([detailData.consultationID, detailData.scopeLineNumber])}> Delete </IonButton>}
                            
                                </IonCol>


                                <IonGrid className='appGridContent'>
                                        <IonRow>
                                            <IonCol>
                                                <h3>Estimates</h3>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow class='gridResultHeaders'>
                                            <IonCol size='4' class='gridResultColumns'>Item Name</IonCol>
                                            <IonCol size='4' class='gridResultColumns'>Price</IonCol>
                                            <IonCol size='4' class='gridResultColumns'>Action</IonCol>
                                        </IonRow>
                                    {viewScopeEstimates.map((detailData1) =>   {
                                            return (
                                                    <IonRow key={detailData1.estimateLineNumber}>
                                                        <IonCol size='4'>{detailData1.itemName}</IonCol>
                                                        <IonCol size='4'>{detailData1.itemEstimatedPrice}</IonCol>
                                                        <IonCol size='4'>

                                                            <IonButton className='appListButton' onClick={() => updateItemHandler([true, detailData1.itemID])}> Update </IonButton>
                                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteScopeItem_estimateHandler([detailData.consultationID, detailData.scopeLineNumber, detailData1.estimateLineNumber])}> Delete </IonButton>}
                                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                                    
                                                        </IonCol>
                                                    </IonRow>
                                            )
                                        }
                                        )}
                                    </IonGrid>

                                    <IonGrid className='appGridContent'>
                                        <IonRow>
                                            <IonCol>
                                                <h3>Expenses</h3>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow class='gridResultHeaders'>
                                            <IonCol class='gridResultColumns'>Item Name</IonCol>
                                            <IonCol class='gridResultColumns'>Price</IonCol>
                                            <IonCol class='gridResultColumns'>Action</IonCol>
                                        </IonRow>
                                    {viewScopeExpenses.map((detailData2) =>   {
                                            return (
                                                    <IonRow key={detailData2.expenseLineNumber}>
                                                        <IonCol size='3'>{detailData2.itemName}</IonCol>
                                                        <IonCol size='3'>{detailData2.itemPrice}</IonCol>
                                                        <IonCol size='3'>
                                                            <IonButton className='appListButton' onClick={() => viewScopeExpenseModalHandler([true, detailData.consultationID,  detailData.scopeLineNumber, detailData2.expenseLineNumber])}> View </IonButton>                                                    
                                                        </IonCol>
                                                    </IonRow>
                                            )
                                        }
                                        )}
                                    </IonGrid>

                            </IonRow>

                            
                    )
                }
                )}


            </div>
            </IonGrid>
        </IonContent>


        <IonFooter className='modal_footer_button_center'>
            <IonGrid>
                {consultationStatus == "INITIAL" && <IonRow>
                    <IonCol>
                        <IonButton  onClick={() => send_customer_approvalRequest(props.data.consultationID)}> Send for Customer Approval </IonButton>
                    </IonCol>
                </IonRow>}
                {consultationStatus == "CUSTOMER_APPROVED" && <IonRow>
                    <IonCol>
                        <IonButton  onClick={() => add_consultationToProject(props.data.consultationID)}> Add To Project</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton  onClick={() => convert_consultationToProject(props.data.consultationID)}> Convert To Project </IonButton>
                    </IonCol>
                </IonRow>}
                <IonRow>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>        
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>

    </IonModal>) : null}

    <ScopeDetailsModal openModal={ showScopeDetailsModal } closeModal={() => setShowScopeDetailsModal(false)} data={{
                                            consultationID: consultationID, 
                                            }}></ScopeDetailsModal>

    <AddScopeModal openModal={ showConsultationDetailsModal } closeModal={() => setShowConsultationDetailsModal(false)} data={{
                                            consultationID: consultationID, 
                                            }}></AddScopeModal>
    
    <AddEstimateItemModal openModal={ addEstimateItemModal } closeModal={() => setAddEstimateItemModal(false)} data={{
                                            consultationID: consultationID, 
                                            scopeLineNumber: scopeLineNumber, 
                                            }}></AddEstimateItemModal>
    </React.Fragment>
    )
}